// extracted by mini-css-extract-plugin
module.exports = {"primary":"Button_primary__3NtLL","bg__disabled":"Button_bg__disabled__2HerP","border":"Button_border__1Djkn","iconText":"Button_iconText__3XGAM","padding":"Button_padding__2lRqV"};